// All Minnesota incorporated cities, townships, and communities
// Source: U.S. Census Bureau / Minnesota state records
export const MN_CITIES: string[] = [
  'Ada',
  'Adams',
  'Adrian',
  'Afton',
  'Aitkin',
  'Albany',
  'Albert Lea',
  'Alberta',
  'Alden',
  'Aldrich',
  'Alexandria',
  'Altura',
  'Alvarado',
  'Amboy',
  'Andover',
  'Annandale',
  'Anoka',
  'Apple Valley',
  'Appleton',
  'Arden Hills',
  'Argyle',
  'Arlington',
  'Ashby',
  'Askov',
  'Atwater',
  'Audubon',
  'Aurora',
  'Austin',
  'Avoca',
  'Avon',
  'Babbitt',
  'Backus',
  'Badger',
  'Bagley',
  'Barnesville',
  'Barnum',
  'Barrett',
  'Barry',
  'Battle Lake',
  'Baudette',
  'Baxter',
  'Bayport',
  'Becker',
  'Belgrade',
  'Belle Plaine',
  'Bellingham',
  'Belview',
  'Bemidji',
  'Benson',
  'Bergen',
  'Big Falls',
  'Big Lake',
  'Bigelow',
  'Bigfork',
  'Bird Island',
  'Biwabik',
  'Blackduck',
  'Blaine',
  'Blomkest',
  'Blooming Prairie',
  'Bloomington',
  'Blue Earth',
  'Bock',
  'Borup',
  'Bovey',
  'Bowlus',
  'Boy River',
  'Boyd',
  'Braham',
  'Brainerd',
  'Brandon',
  'Breckenridge',
  'Breezy Point',
  'Brook Park',
  'Brooklyn Center',
  'Brooklyn Park',
  'Brooks',
  'Brooten',
  'Browerville',
  'Browns Valley',
  'Brownsdale',
  'Brownton',
  'Bruno',
  'Buffalo',
  'Buffalo Lake',
  'Buhl',
  'Burnsville',
  'Burtrum',
  'Byron',
  'Caledonia',
  'Campbell',
  'Cannon Falls',
  'Carlton',
  'Carver',
  'Cass Lake',
  'Cedar Mills',
  'Center City',
  'Centerville',
  'Ceylon',
  'Champlin',
  'Chaska',
  'Chatfield',
  'Chisago City',
  'Chisholm',
  'Chokio',
  'Circle Pines',
  'Clara City',
  'Claremont',
  'Clarissa',
  'Clarkfield',
  'Clearbrook',
  'Clearwater',
  'Cleveland',
  'Clinton',
  'Clontarf',
  'Cloquet',
  'Cohasset',
  'Cokato',
  'Cold Spring',
  'Coleraine',
  'Cologne',
  'Columbia Heights',
  'Columbus',
  'Comfrey',
  'Comstock',
  'Conger',
  'Cook',
  'Cosmos',
  'Cottage Grove',
  'Cottonwood',
  'Courtland',
  'Cromwell',
  'Crookston',
  'Crosby',
  'Crystal',
  'Crystal Bay',
  'Currie',
  'Cuyuna',
  'Cyrus',
  'Dalton',
  'Danube',
  'Danvers',
  'Darfur',
  'Darwin',
  'Dassel',
  'Dawson',
  'Dayton',
  'De Graff',
  'Deephaven',
  'Deer Creek',
  'Deer River',
  'Deerwood',
  'Delano',
  'Delavan',
  'Delhi',
  'Denham',
  'Dennison',
  'Dent',
  'Detroit Lakes',
  'Dexter',
  'Dilworth',
  'Dodge Center',
  'Donaldson',
  'Donnelly',
  'Doran',
  'Dover',
  'Dovray',
  'Duluth',
  'Dumont',
  'Dundas',
  'Dundee',
  'Dunnell',
  'Eagle Bend',
  'Eagle Lake',
  'East Bethel',
  'East Grand Forks',
  'East Gull Lake',
  'Easton',
  'Eden Prairie',
  'Eden Valley',
  'Edgerton',
  'Edina',
  'Effie',
  'Eitzen',
  'Elba',
  'Elbow Lake',
  'Elgin',
  'Elizabeth',
  'Elk River',
  'Elko New Market',
  'Elkton',
  'Ellsworth',
  'Elmore',
  'Elrosa',
  'Ely',
  'Elysian',
  'Emily',
  'Emmons',
  'Erhard',
  'Erskine',
  'Evansville',
  'Eveleth',
  'Excelsior',
  'Eyota',
  'Fairfax',
  'Fairmont',
  'Falcon Heights',
  'Faribault',
  'Farmington',
  'Farwell',
  'Fergus Falls',
  'Fertile',
  'Fifty Lakes',
  'Finlayson',
  'Fisher',
  'Flensburg',
  'Floodwood',
  'Florence',
  'Foley',
  'Forada',
  'Forest Lake',
  'Foreston',
  'Fort Ripley',
  'Fosston',
  'Fountain',
  'Foxhome',
  'Franklin',
  'Frazee',
  'Freeborn',
  'Freeport',
  'Fridley',
  'Frost',
  'Fulda',
  'Funkley',
  'Garfield',
  'Gary',
  'Gem Lake',
  'Gilbert',
  'Gilman',
  'Glencoe',
  'Glenville',
  'Glenwood',
  'Glyndon',
  'Golden Valley',
  'Gonvick',
  'Good Thunder',
  'Goodhue',
  'Goodridge',
  'Goodview',
  'Graceville',
  'Graettinger',
  'Granada',
  'Grand Marais',
  'Grand Meadow',
  'Grand Rapids',
  'Granite Falls',
  'Grant',
  'Greenbush',
  'Greenfield',
  'Greenway',
  'Greenwood',
  'Grey Eagle',
  'Grove City',
  'Grygla',
  'Gully',
  'Hackensack',
  'Hallock',
  'Halstad',
  'Ham Lake',
  'Hamburg',
  'Hammond',
  'Hampton',
  'Hancock',
  'Hanley Falls',
  'Hanska',
  'Hardwick',
  'Harmony',
  'Harris',
  'Hartland',
  'Hastings',
  'Hatfield',
  'Hawley',
  'Hayfield',
  'Hector',
  'Henderson',
  'Hendricks',
  'Hendrum',
  'Henning',
  'Herman',
  'Hermantown',
  'Heron Lake',
  'Hewitt',
  'Hibbing',
  'Hills',
  'Hinckley',
  'Hitterdal',
  'Hopkins',
  'Houston',
  'Howard Lake',
  'Hoyt Lakes',
  'Hugo',
  'Humboldt',
  'Hutchinson',
  'International Falls',
  'Inver Grove Heights',
  'Iona',
  'Iron Junction',
  'Ironton',
  'Isle',
  'Ivanhoe',
  'Jackson',
  'Jacobson',
  'Janesville',
  'Jasper',
  'Jeffers',
  'Jenkins',
  'Johnson',
  'Jordan',
  'Kandiyohi',
  'Karlstad',
  'Kasota',
  'Kasson',
  'Keewatin',
  'Kellogg',
  'Kennedy',
  'Kenyon',
  'Kerkhoven',
  'Kiester',
  'Kimball',
  'Kingston',
  'La Crescent',
  'La Prairie',
  'Lakefield',
  'Lake Benton',
  'Lake City',
  'Lake Crystal',
  'Lake Elmo',
  'Lake Park',
  'Lake Shore',
  'Lake St. Croix Beach',
  'Lakeland',
  'Lakeland Shores',
  'Lakeville',
  'Lancaster',
  'Lanesboro',
  'Laporte',
  'Le Center',
  'Le Roy',
  'Le Sueur',
  'Lengby',
  'Leonard',
  'Leota',
  'Lester Prairie',
  'Lewiston',
  'Lewisville',
  'Lindstrom',
  'Lino Lakes',
  'Lismore',
  'Litchfield',
  'Little Canada',
  'Little Falls',
  'Little Fork',
  'Long Lake',
  'Long Prairie',
  'Longville',
  'Lonsdale',
  'Loretto',
  'Lowry',
  'Lucan',
  'Luverne',
  'Lyle',
  'Lynd',
  'Mabel',
  'Madelia',
  'Madison',
  'Madison Lake',
  'Mahnomen',
  'Mahtomedi',
  'Mankato',
  'Mantorville',
  'Maple Grove',
  'Maple Lake',
  'Maple Plain',
  'Mapleton',
  'Mapleview',
  'Maplewood',
  'Marble',
  'Marietta',
  'Marshall',
  'Mayer',
  'McGregor',
  'McIntosh',
  'Meadowlands',
  'Medford',
  'Medina',
  'Melrose',
  'Menahga',
  'Mendota',
  'Mendota Heights',
  'Mentor',
  'Milaca',
  'Milan',
  'Millville',
  'Miltona',
  'Minneapolis',
  'Minneota',
  'Minnesota City',
  'Minnesota Lake',
  'Minnetonka',
  'Minnetonka Beach',
  'Minnetrista',
  'Mizpah',
  'Montevideo',
  'Montgomery',
  'Monticello',
  'Montrose',
  'Moorhead',
  'Moose Lake',
  'Mora',
  'Morgan',
  'Morris',
  'Morristown',
  'Morton',
  'Motley',
  'Mound',
  'Mounds View',
  'Mountain Iron',
  'Mountain Lake',
  'Murdock',
  'Myrtle',
  'Nerstrand',
  'Nevis',
  'New Auburn',
  'New Brighton',
  'New Germany',
  'New Hope',
  'New London',
  'New Market',
  'New Prague',
  'New Richland',
  'New Ulm',
  'New York Mills',
  'Newport',
  'Nicollet',
  'Nielsville',
  'Nisswa',
  'North Branch',
  'North Mankato',
  'North Oaks',
  'North Redwood',
  'North St. Paul',
  'Northfield',
  'Northome',
  'Norwood Young America',
  'Oak Grove',
  'Oak Park Heights',
  'Oakdale',
  'Odin',
  'Ogema',
  'Ogilvie',
  'Okabena',
  'Olivia',
  'Onamia',
  'Orono',
  'Oronoco',
  'Orr',
  'Ortonville',
  'Osakis',
  'Oslo',
  'Osseo',
  'Ostrander',
  'Owatonna',
  'Palisade',
  'Park Rapids',
  'Parkers Prairie',
  'Paynesville',
  'Pelican Rapids',
  'Pemberton',
  'Pennock',
  'Pequot Lakes',
  'Perham',
  'Pierz',
  'Pillager',
  'Pine City',
  'Pine Island',
  'Pine River',
  'Pipestone',
  'Plainview',
  'Plato',
  'Pleasant Lake',
  'Plummer',
  'Plymouth',
  'Ponemah',
  'Porter',
  'Preston',
  'Princeton',
  'Prinsburg',
  'Prior Lake',
  'Proctor',
  'Ramsey',
  'Randall',
  'Randolph',
  'Raymond',
  'Red Lake Falls',
  'Red Wing',
  'Redwood Falls',
  'Remer',
  'Renville',
  'Rice',
  'Richfield',
  'Richmond',
  'Richville',
  'Robbinsdale',
  'Rochester',
  'Rock Creek',
  'Rockford',
  'Rockville',
  'Rogers',
  'Rollingstone',
  'Roosevelt',
  'Roseau',
  'Rosemount',
  'Roseville',
  'Round Lake',
  'Royalton',
  'Rush City',
  'Rushford',
  'Rushford Village',
  'Russell',
  'Ruthton',
  'Rutledge',
  'Sacred Heart',
  'Saint Anthony',
  'Saint Augusta',
  'Saint Bonifacius',
  'Saint Charles',
  'Saint Cloud',
  'Saint Francis',
  'Saint James',
  'Saint Joseph',
  'Saint Leo',
  'Saint Louis Park',
  'Saint Martin',
  'Saint Michael',
  'Saint Paul',
  'Saint Paul Park',
  'Saint Peter',
  'Saint Rosa',
  'Saint Stephen',
  'Saint Vincent',
  'Sanborn',
  'Sandstone',
  'Sauk Centre',
  'Sauk Rapids',
  'Savage',
  'Scanlon',
  'Seaforth',
  'Shafer',
  'Shakopee',
  'Shelly',
  'Sherburn',
  'Shoreview',
  'Shorewood',
  'Silver Bay',
  'Silver Lake',
  'Slayton',
  'Sleepy Eye',
  'Soudan',
  'South Haven',
  'South St. Paul',
  'Spicer',
  'Spring Grove',
  'Spring Hill',
  'Spring Lake Park',
  'Spring Park',
  'Spring Valley',
  'Springfield',
  'Squaw Lake',
  'Stacy',
  'Staples',
  'Starbuck',
  'Steen',
  'Stephen',
  'Stewart',
  'Stewartville',
  'Stillwater',
  'Stockholm',
  'Storden',
  'Strandquist',
  'Strathcona',
  'Sturgeon Lake',
  'Sunburg',
  'Sunfish Lake',
  'Swanville',
  'Taunton',
  'Taylors Falls',
  'Thief River Falls',
  'Thomson',
  'Tintah',
  'Tower',
  'Tracy',
  'Trimont',
  'Trosky',
  'Truman',
  'Twin Valley',
  'Two Harbors',
  'Tyler',
  'Ulen',
  'Underwood',
  'Upsala',
  'Urbank',
  'Utica',
  'Vadnais Heights',
  'Vernon Center',
  'Verndale',
  'Victoria',
  'Viking',
  'Virginia',
  'Wabasha',
  'Wabasso',
  'Waconia',
  'Wadena',
  'Wahkon',
  'Waite Park',
  'Walker',
  'Walnut Grove',
  'Waltham',
  'Warren',
  'Warroad',
  'Waseca',
  'Waterville',
  'Watkins',
  'Watson',
  'Waubun',
  'Wayzata',
  'Welcome',
  'Wells',
  'West Concord',
  'West St. Paul',
  'West Union',
  'Westbrook',
  'Wheaton',
  'White Bear Lake',
  'Willernie',
  'Williams',
  'Willmar',
  'Willow River',
  'Wilmont',
  'Wilton',
  'Windom',
  'Winger',
  'Winnebago',
  'Winona',
  'Winsted',
  'Winthrop',
  'Wolverton',
  'Wood Lake',
  'Woodbury',
  'Woodstock',
  'Worthington',
  'Wrenshall',
  'Wright',
  'Wyoming',
  'Young America',
  'Zimmerman',
  'Zumbrota',
];
